/**
 * Объект частично совместим с объектом конфига роутера, но в данный момент **не поддерживаются вложенные пути**
 */
export const cardsRoutes = [
    {
        name: 'cards',
        path: '/cards/',
        component: () => import(/* webpackChunkName: "cards" */ '/local/templates/redesign/src/pages/cards/cardsIndexPage.vue'),
    },
    {
        name: 'cards-getcc',
        path: '/cards/getcc/(.*)',
        component: () => import(/* webpackChunkName: "cardsGetccPage" */ '/local/templates/redesign/src/pages/cards/cardsGetccPage.vue'),
    },
    {
        name: 'cards-multicurrency',
        path: '/cards/multicurrency/(.*)',
        component: () => import(/* webpackChunkName: "cardsMulticurrencyPage" */ '/local/templates/redesign/src/pages/cards/cardsMulticurrencyPage.vue'),
    },
    {
        name: 'cards-limit',
        path: '/cards/limit/(.*)',
        component: () => import(/* webpackChunkName: "cardsLimitPage" */ '/local/templates/redesign/src/pages/cards/cardsLimitPage.vue'),
    },
    {
        name: 'cards-offer',
        path: '/cards/offer-(.*)-card/',
        component: () => import(/* webpackChunkName: "cardsOffer" */ '/local/templates/redesign/src/pages/cards/cardsOffer.vue'),
    },
    {
        name: 'cards-debit-credit',
        path: '/cards/:product(debit|credit)?/(.*)',
        component: () => import(/* webpackChunkName: "cardsDebitCreditPage" */ '/local/templates/redesign/src/pages/cards/cardsDebitCreditPage.vue'),
    },
    {
        name: 'cards-detail',
        path: '/cards/:product/(.*)',
        component: () => import(/* webpackChunkName: "cardsDetailPage" */ '/local/templates/redesign/src/pages/cards/cardsDetailPage.vue'),
    },
    {
        name: 'salary',
        path: '/salary-card/',
        component: () => import(/* webpackChunkName: "cardsDetailPage" */ '/local/templates/redesign/src/pages/cards/cardsDetailPage.vue'),
    },
];
